export const AuditAdminData = {
  cbOfficeLocation: {
    label: "CB Office Location",
    type: "select",
    options: [
      { value: "India", label: "India" },
      { value: "US", label: "US" },
      { value: "UK", label: "UK" },
    ],
    required: true,
    name: "cb_office_location",
  },
  auditLanguage: {
    label: "Audit Language",
    type: "select",
    options: [
      { value: "Hindi", label: "Hindi" },
      { value: "English", label: "English" },
    ],
    required: true,
    name: "audit_language",
  },
  fsscCertificationAudit: {
    label: "Will this be done in Conjunction with FSSC Certification Audit",
    type: "radio",
    options: [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ],
    required: true,
    name: "is_fssc_conjunction",
  },
  auditCriteria: {
    label: "Audit Criteria (Applicable Standard or Technical Specifications)",
    type: "select",
    options: [
      { value: "MARS QMS Version 0", label: "MARS QMS Version 0" },
      {
        value: "ISO 22000: 2018 Food Safety Management Systems",
        label: "ISO 22000: 2018 Food Safety Management Systems",
      },
      {
        value: "FSSC 22000 Additional Requirements (Version 6.0)",
        label: "FSSC 22000 Additional Requirements (Version 6.0)",
      },
      {
        value: "ISO/TS 22002-1: 2009 - Food Manufacturing",
        label: "ISO/TS 22002-1: 2009 - Food Manufacturing",
      },
      {
        value: "ISO/TS 22002-4: 2013 - Food Packaging Manufacturing",
        label: "ISO/TS 22002-4: 2013 - Food Packaging Manufacturing",
      },
      {
        value: "ISO/TS 22002-5: 2019 - Transport & Storage",
        label: "ISO/TS 22002-5: 2019 - Transport & Storage",
      },
      {
        value: "ISO/TS 22002-6: 2016 - Feed & Animal Food Production",
        label: "ISO/TS 22002-6: 2016 - Feed & Animal Food Production",
      },
    ],

    required: true,
    name: "audit_criteria",
  },
  auditDelivery: {
    label: "Audit Delivery",
    type: "select",
    options: [
      { value: "Onsite", label: "Onsite" },
      { value: "Full Remote ", label: "Full Remote" },
      {
        value: "Hybrid (Part onsite and part remote)",
        label: "Hybrid (Part onsite and part remote)",
      },
    ],
    required: true,
    name: "audit_delivery",
  },
  auditStartDate: {
    label: "Audit Start Date",
    type: "date",
    placeholder: "Enter Start Date",
    required: true,
    name: "audit_start_date",
  },
  auditEndDate: {
    label: "Audit End Date",
    type: "date",
    placeholder: "Enter End Date",
    required: true,
    name: "audit_end_date",
  },
  auditType: {
    label: "Audit Type",
    type: "select",
    options: [
      { value: "sustaining", label: "Sustaining Unit Audit" },
      { value: "gap assessment", label: "Gap Assessment" },
    ],
    required: true,
    name: "audit_type",
  },
  auditFocusArea: {
    label: "Audit Focus Area",
    type: "text",
    placeholder: "Enter Audit Focus Area",
    required: true,
  },
  version: {
    label: "Version",
    type: "number",
    placeholder: "1",
    required: false,
    name: "version",
  },
  jobnumber: {
    label: "Job Number",
    type: "text",
    placeholder: "Your Job Number",
    required: true,
    name: "jobnumber",
  },
  correctiveActionDate: {
    label: "Corrective Action Date",
    type: "date",
    placeholder: "Enter Corrective Action Date",
    required: false,
    name: "corrective_action_date",
  },
};
